/**
 * Organisation-related constants
 */

export const BUSINESS_TYPES = [
  { id: 1, label: 'Retail' },
  { id: 2, label: 'Service' },
  { id: 3, label: 'Manufacturing' },
  { id: 4, label: 'Technology' },
  { id: 5, label: 'Healthcare' },
  { id: 6, label: 'Education' },
  { id: 7, label: 'Hospitality' },
  { id: 8, label: 'Other' },
];

export const MONETARY_CURRENCIES = [
  { id: 840, label: 'USD - US Dollar' },
  { id: 826, label: 'GBP - British Pound' },
  { id: 978, label: 'EUR - Euro' },
];

export const ROLE_TYPES = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  MEMBER: 'Member',
};
